import {
  Children,
  isValidElement,
  type PropsWithChildren,
  type ReactNode,
} from 'react';

import { isSlot } from '../../../../../core/utils/is-slot.js';
import { TrackAtom } from '../slots/TrackAtom.js';

/**
 * Extract all visible TrackAtom components,
 * checking deeper in case they are grouped into a wrapper component
 *
 * @param elements -
 */
export function extractVisibleTracks(children: ReactNode): ReactNode {
  const elementsArray: ReactNode[] = [];
  Children.forEach(children, (child) => {
    if (isSlot(child, TrackAtom)) {
      if (!child.props.hidden) {
        // Search first for the TrackAtom
        elementsArray.push(child);
      }
    } else if (isValidElement<PropsWithChildren>(child)) {
      // Check one level deep if not present
      return extractVisibleTracks(child.props.children);
    }
  });

  return elementsArray;
}
